import React from "react";

import { HOCType } from "../../constants/types";
import { PlacementWorksheetProvider } from "./PlacementWorksheetProvider";

export const withPlacementWorksheetProvider: HOCType = (WrappedComponent) => (props) => (
  <PlacementWorksheetProvider>
    <WrappedComponent {...props} />
  </PlacementWorksheetProvider>
);
